// extracted by mini-css-extract-plugin
export var tab = "s_fS";
export var tabActive = "s_fT";
export var hide = "s_bG";